import { put, select, takeLatest } from 'redux-saga/effects'
import { SignaturesConstants } from '../store/signatures.constants'
import { getSignaturesSelector } from '../selectors/getSignatures.selector'
import { ISignaturesState } from '../store/signatures.types'
import {
  saveSignaturesPcr,
  saveTempSignature,
  setCrew,
  setReceivingFacilityPrintedName,
  setReceivingFacilityTitle,
  setRepresentativePrintedName,
  setSectionThreeReasonIncapableOfSigning,
  setSectionThreeSelectedOptionIncapableOfSigning,
  setSectionTwoReasonIncapableOfSigning,
  setSectionTwoSelectedOptionIncapableOfSigning,
  setSelectedSignatureType,
  setSignatureSection,
  setWitnessPrintedName,
  setWitnessPhone,
  setWitnessAddress,
  setRepresentativePhone,
  setRepresentativeAddress,
  setSectionTwoAuthorizedRepresentative,
} from '../store/signatures.actions'

export function* clearSignatureData() {
  const signatureState: ISignaturesState = yield select(getSignaturesSelector)
  const { selectedSignatureType, chips, signatureOldChipData } = signatureState
  const {
    witnessPrintedName,
    witnessAddress,
    witnessPhone,
    sectionTwoReasonIncapableOfSigning,
    sectionTwoSelectedOptionIncapableOfSigning,
    representativePrintedName,
    sectionThreeReasonIncapableOfSigning,
    sectionThreeSelectedOptionIncapableOfSigning,
    crew,
    receivingFacilityPrintedName,
    receivingFacilityRepTitle,
  } = signatureOldChipData

  if (selectedSignatureType?.signatureType === SignaturesConstants.PATIENT) {
    yield put(saveTempSignature(''))
  } else if (selectedSignatureType?.signatureType === SignaturesConstants.WITNESS) {
    yield put(saveTempSignature(''))
    yield put(setWitnessPrintedName(witnessPrintedName))
    yield put(setWitnessPhone(witnessPhone))
    yield put(setWitnessAddress(witnessAddress))
  } else if (selectedSignatureType?.signatureType === SignaturesConstants.AMBULANCE) {
    yield put(saveTempSignature(''))
  } else if (selectedSignatureType?.signatureType === SignaturesConstants.REPRESENTATIVE) {
    yield put(saveTempSignature(''))
    yield put(setSectionTwoSelectedOptionIncapableOfSigning(sectionTwoSelectedOptionIncapableOfSigning))
    yield put(setSectionTwoReasonIncapableOfSigning(sectionTwoReasonIncapableOfSigning))
    yield put(setRepresentativePrintedName(representativePrintedName))
    yield put(setRepresentativePhone(''))
    yield put(setRepresentativeAddress(''))
    yield put(setSectionTwoAuthorizedRepresentative(null))
  } else if (selectedSignatureType?.signatureType === SignaturesConstants.CREW) {
    yield put(saveTempSignature(''))
    yield put(setCrew(crew))
    const isReceivingPresent = chips.find((chipObj) => {
      return chipObj.option?.signatureType === SignaturesConstants.RECEIVING
    })
    if (!isReceivingPresent) {
      yield put(setSectionThreeSelectedOptionIncapableOfSigning(sectionThreeSelectedOptionIncapableOfSigning))
      yield put(setSectionThreeReasonIncapableOfSigning(sectionThreeReasonIncapableOfSigning))
    }
  } else if (selectedSignatureType?.signatureType === SignaturesConstants.RECEIVING) {
    yield put(saveTempSignature(''))
    yield put(setReceivingFacilityPrintedName(receivingFacilityPrintedName))
    yield put(setReceivingFacilityTitle(receivingFacilityRepTitle))
    const isCrewPresent = chips.find((chipObj) => {
      return chipObj.option?.signatureType === SignaturesConstants.CREW
    })
    if (!isCrewPresent) {
      yield put(setSectionThreeSelectedOptionIncapableOfSigning(sectionThreeSelectedOptionIncapableOfSigning))
      yield put(setSectionThreeReasonIncapableOfSigning(sectionThreeReasonIncapableOfSigning))
    }
  }
  yield put(setSelectedSignatureType(null))
  yield put(setSignatureSection(null))
  yield put(saveSignaturesPcr())
}

export function* clearSignatureDataSaga() {
  yield takeLatest([SignaturesConstants.CLEAR_SIGNATURE_DATA], clearSignatureData)
}
